import { USER_LANGUAGE_URL } from 'constants/config';
import { fetchJson } from 'utils/fetchJson/fetchJson';

const userLanguage = {
  update: (senderEmail: string, locale: string) => {
    const payload = {
      user: {
        email: senderEmail,
        language: locale,
      },
    };
    const body = JSON.stringify(payload);
    const options = { body, method: 'PUT' };

    return fetchJson(USER_LANGUAGE_URL, options);
  },
};

export { userLanguage };
